import { FileText, Layers } from 'lucide-react'

import type { InterviewerBriefContext } from '../../hooks/use-interviewer-candidates'

/** Which brief (and role) a queued candidate came from, plus the recruiter's note. */
export function InterviewerBriefContextLine({ context }: { context: InterviewerBriefContext }) {
  if (!context.brief_id) return null
  const notes = context.recruiter_notes?.trim()
  return (
    <div className="space-y-1 text-xs text-muted-foreground">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="inline-flex min-w-0 items-center gap-1">
          <FileText className="size-3.5 shrink-0" aria-hidden />
          <span className="truncate">{context.brief_title}</span>
        </span>
        {context.role_title ? (
          <span className="inline-flex min-w-0 items-center gap-1">
            <Layers className="size-3.5 shrink-0" aria-hidden />
            <span className="truncate">{context.role_title}</span>
          </span>
        ) : null}
      </div>
      {notes ? <p className="line-clamp-2">Recruiter: {notes}</p> : null}
    </div>
  )
}
